import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import { deleteCompany, getCompanies, importCompanies } from "../../../api/companies"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { Button, Input } from "reactstrap"
import ImportCard from "../../../components/ImportModal"
import ImportModal from "../../../components/ImportModal"
import TableFilter from "../../../components/TableFilter"


export default function CompaniesTable() {

  const { t } = useTranslation()
  let navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getCompanies)

  // Filter
  const filterTypes = [
    {key: "name", type: "text"},
  ]


  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingCompany, setDeletingCompany] = useState(null)

  const { setData } = useResponse(deleteCompany, () => {
    setShow(false)
    setDeletingCompany(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingCompany })
  }

  ///////////

  const [importModalOpen, setImportModalOpen] = useState(false)


  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.COMPANY_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-company"
      >
       <div style={{marginRight: "15px"}}>
        <Button onClick={() => setImportModalOpen(true)} color="info">Import</Button>
       </div>
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({page: 1, payload: filters})}
      />

      <ImportCard />
      
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th style={{ width: "25%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.companies.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td style={{cursor: "pointer"}} onClick={() => navigate.push('/company/'+row.id)}>{row.name}</Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.COMPANY_EDIT}
                          deletePermission={PERMISSIONS.COMPANY_DELETE}
                          type="company"
                          id={row.id}
                          editUrl={'edit-company/'+row.id+'/all'}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingCompany}
                        />
                        {/*<Button onClick={() => navigate.push('company/'+row.id+'/contracts')}>
                          <i className="bx bx-notepad font-size-16 align-middle" />
                        </Button>
                        <Button onClick={() => navigate.push('company/'+row.id+'/contacts')}>
                          <i className="bx bxs-contact font-size-16 align-middle" />
                        </Button>*/}
                        <Button style={{marginLeft: "5px"}} color="dark" onClick={() => navigate.push('company/'+row.id)}>
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.companies.length === 0} msg="No Companies Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          <ImportModal 
          fileName="erp_import_companies_template.xlsx"
          isOpen={importModalOpen} 
          onCloseClick={() => {setImportModalOpen(false)}} 
          api={importCompanies}
           handleRefresh={() => setPayload({refresh: true})}
          />


          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
